import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _pt from 'prop-types';
import { Children } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import invariant from 'tiny-invariant';
import { PageUnauthorized } from '@commercetools-frontend/application-components';
import { entryPointUriPathToPermissionKeys } from '@commercetools-frontend/application-config/ssr';
import { useIsAuthorized } from '@commercetools-frontend/permissions';
import { R as RouteCatchAll } from './index-b6081c20.esm.js';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const ApplicationRouteWithPermissionCheck = props => {
  const permissionKeys = entryPointUriPathToPermissionKeys(props.environment.entryPointUriPath);
  // Require View permission to render the application.
  const canView = useIsAuthorized({
    demandedPermissions: [permissionKeys.View]
  });
  if (canView) {
    return jsx(Fragment, {
      children: Children.only(props.children)
    });
  }
  return jsx(PageUnauthorized, {});
};
ApplicationRouteWithPermissionCheck.propTypes = process.env.NODE_ENV !== "production" ? {
  disableRoutePermissionCheck: _pt.bool,
  render: _pt.func,
  children: _pt.node
} : {};
const ApplicationRoute = props => {
  if (props.disableRoutePermissionCheck) {
    return jsx(Fragment, {
      children: Children.only(props.children)
    });
  }
  return jsx(ApplicationRouteWithPermissionCheck, _objectSpread({}, props));
};
ApplicationRoute.propTypes = process.env.NODE_ENV !== "production" ? {
  disableRoutePermissionCheck: _pt.bool,
  render: _pt.func,
  children: _pt.node
} : {};
const ApplicationEntryPoint = props => {
  // If the `children` prop is used (instead of the `render` prop),
  // we pre-configure the application entry point routes to avoid
  // users to do so on their own.
  if (props.children) {
    const entryPointUriPath = props.environment.entryPointUriPath;
    return jsxs(Switch, {
      children: [
      // For development, it's useful to redirect to the actual
      // application routes when you open the browser at http://localhost:3001
      process.env.NODE_ENV === 'production' ? null : jsx(Route, {
        exact: true,
        path: "/:projectKey",
        render: _ref => {
          let match = _ref.match;
          const projectKey = match.params.projectKey;
          return jsx(Redirect, {
            to: `/${projectKey}/${entryPointUriPath}`
          });
        }
      }), jsx(Route, {
        path: `/:projectKey/${entryPointUriPath}`,
        children: jsx(ApplicationRoute, _objectSpread({}, props))
      }), jsx(RouteCatchAll, {})]
    });
  }

  // We still support the `render` prop, for backwards compatibility
  // and for having more control in certain cases (mostly to some of our internal apps).
  if (props.render && typeof props.render === 'function') {
    return jsx(Fragment, {
      children: props.render()
    });
  }

  // The `render` prop function is still required (backwards compatibility).
  !!props.render ? process.env.NODE_ENV !== "production" ? invariant(false, '@commercetools-frontend/application-shell: Missing required function prop "render".') : invariant(false) : void 0;
  return null;
};
ApplicationEntryPoint.propTypes = process.env.NODE_ENV !== "production" ? {
  disableRoutePermissionCheck: _pt.bool,
  render: _pt.func,
  children: _pt.node
} : {};

export { ApplicationEntryPoint as A };
